<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu contentId="main-content" type="overlay">
      <ion-header class="ion-no-border">
        <ion-toolbar>
          <ion-img
            [class]="getLogoClass()"
            [src]="getLogo()"
            (click)="forceASentryError()"
          ></ion-img>
        </ion-toolbar>
      </ion-header>
      <ion-content>
        <ion-list id="inbox-list" lines="none">
          <ion-note
            *ngIf="(authService.isLoggedIn() | async) && authService.userData"
            (click)="forceAnError()"
          >
            <span style="margin-right: 10px">
              {{
                authService.userData.firstName +
                  ' ' +
                  authService.userData.lastName
              }}
            </span>

            <!-- Tier badge (Bronze/Silver/Gold) — hidden at level 0 -->
            <app-quality-bonus-status
              *ngIf="shouldDisplayStatusBadge()"
              [premiumPartnerLevel]="profileService.premiumPartnerLevel"
            />

            <!-- Onboarding not complete -->
            <ion-chip
              *ngIf="showOnboardingStateBadge"
              class="status-badge"
              color="medium"
            >
              {{ 'movacarpro_onboarding_state_status_0' | translate }}
            </ion-chip>

            <!-- Onboarded but no status yet -->
            <span class="status-badges" *ngIf="showTrainingRequiredBadge">
              <ion-chip class="status-badge" color="success">
                {{ 'movacarpro_onboarding_state_active' | translate }}
              </ion-chip>
              <ion-chip class="status-badge" color="warning">
                {{ 'movacarpro_status_badge_training_required' | translate }}
              </ion-chip>
              <ion-icon
                (click)="onInfoIconClick()"
                class="info-icon"
                [class.info-icon--open]="isBonusPanelOpen"
                color="primary"
                name="chevron-down-circle"
              />
            </span>

            <!-- Bonus info -->
            <ion-icon
              *ngIf="shouldDisplayBonusInfo()"
              (click)="onInfoIconClick()"
              class="info-icon"
              [class.info-icon--open]="isBonusPanelOpen"
              color="primary"
              name="chevron-down-circle"
            />
          </ion-note>

          <app-status-bonus-panel
            *ngIf="shouldDisplayBonusInfo()"
            [open]="isBonusPanelOpen"
            [premiumPartnerLevel]="profileService.premiumPartnerLevel"
          />

          <!-- Training-required instruction (onboarded, no status yet) -->
          <div
            *ngIf="showTrainingRequiredBadge && isBonusPanelOpen"
            class="status-hint"
          >
            <p class="status-hint__text">
              {{ 'movacarpro_status_training_required_hint' | translate }}
            </p>
            <ion-menu-toggle auto-hide="false">
              <ion-button
                class="status-hint__cta"
                size="small"
                fill="clear"
                [routerLink]="['/qualifications/']"
                [queryParams]="{ segment: 'basic-training' }"
              >
                {{
                  'movacarpro_qualifications_segment_basic_training' | translate
                }}
                <ion-icon slot="end" name="arrow-forward"></ion-icon>
              </ion-button>
            </ion-menu-toggle>
          </div>

          <!-- admin pages start -->

          <ng-template [ngIf]="this.authService.isLoggedIn() | async">
            <ion-accordion-group
              *ngIf="userAdminInspectionPages.length && adminMenuActive"
            >
              <ion-accordion>
                <ion-item slot="header" lines="none" detail="false">
                  <ion-icon
                    aria-hidden="true"
                    slot="start"
                    ios="car-sport-outline"
                    md="car-sport-sharp"
                  ></ion-icon>

                  <ion-label class="legal-label">{{
                    'Vehicle Inspection'
                  }}</ion-label>
                </ion-item>

                <ion-menu-toggle
                  *ngFor="let p of userAdminInspectionPages"
                  slot="content"
                  auto-hide="false"
                >
                  <ion-item
                    routerDirection="root"
                    [routerLink]="[p.url]"
                    lines="none"
                    detail="false"
                    routerLinkActive="selected"
                  >
                    <ion-label>{{ p.title | translate | titlecase }}</ion-label>
                  </ion-item>
                </ion-menu-toggle>
              </ion-accordion>
            </ion-accordion-group>
          </ng-template>

          <ng-template
            [ngIf]="(this.authService.isLoggedIn() | async) && adminMenuActive"
          >
            <ion-item
              *ngFor="let userAdminPage of userAdminPages"
              [routerLink]="[userAdminPage.url]"
            >
              <ion-icon
                aria-hidden="true"
                slot="start"
                [ios]="userAdminPage.icon"
                [md]="userAdminPage.icon"
              ></ion-icon>
              <ion-label>{{ userAdminPage.title }}</ion-label>
            </ion-item>
            <ion-menu-toggle auto-hide="false">
              <ion-item
                button=""
                lines="none"
                detail="false"
                (click)="closeAdminMode()"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  ios="arrow-back"
                  md="arrow-back"
                ></ion-icon>
                <ion-label> {{ 'Back to Movacar' }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-template>
          <!-- admin pages end -->

          <app-fleet-menu
            *ngIf="
              (authService.isLoggedIn() | async) &&
              authService?.role === UserRole.FleetManager
            "
          />

          <ng-template [ngIf]="this.authService.isLoggedIn() | async">
            <ng-template ngIf="!adminMenuActive">
              <ion-menu-toggle auto-hide="false" *ngFor="let p of userPages">
                <ng-template
                  [ngIf]="
                    (p.url === '/transfers/' ||
                      p.url === '/qualifications/' ||
                      profileService.premiumPartnerLevel > 0) &&
                    !adminMenuActive
                  "
                >
                  <ion-item
                    *ngIf="
                      !(
                        p.title === 'movacarpro_menu_drivers' &&
                        authService?.role === UserRole.SingleDriver
                      ) &&
                      !(
                        p.title === 'movacarpro_menu_transfers' &&
                        !this.companyService.company?.isActive
                      ) &&
                      !(
                        p.url === '/qualifications/' && showOnboardingStateBadge
                      ) &&
                      !adminMenuActive
                    "
                    routerDirection="root"
                    [routerLink]="[p.url]"
                    lines="none"
                    detail="false"
                    routerLinkActive="selected"
                    (click)="p.title === 'Admin mode' && openAdminMenu()"
                  >
                    <ion-icon
                      aria-hidden="true"
                      slot="start"
                      [ios]="p.icon"
                      [md]="p.icon"
                    ></ion-icon>
                    <ion-label>{{ p.title | translate | titlecase }}</ion-label>
                  </ion-item>
                </ng-template>
              </ion-menu-toggle>
            </ng-template>

            <ion-list-header lines="full"></ion-list-header>

            <ion-accordion-group *ngIf="!adminMenuActive">
              <ion-accordion>
                <ion-item slot="header" lines="none" detail="false">
                  <ion-icon
                    aria-hidden="true"
                    slot="start"
                    ios="person-outline"
                    md="person-sharp"
                  ></ion-icon>
                  <ion-label class="legal-label">{{
                    'movacarpro_profile_title' | translate
                  }}</ion-label>
                </ion-item>

                <ng-template [ngIf]="this.authService.isLoggedIn() | async">
                  <ion-menu-toggle                    
                    slot="content"
                    auto-hide="false"
                  >
                  <ion-item
                    *ngIf="showOnboardingEntry"
                    [routerLink]="[onboardingEntry.url]"
                  >
                     <ion-icon
                        style="color: transparent"
                        aria-hidden="true"
                        slot="start"
                        [ios]="onboardingEntry.icon + '-outline'"
                        [md]="onboardingEntry.icon + '-sharp'"
                      ></ion-icon>
                      <ion-label>{{
                        onboardingEntry.title | translate | titlecase
                      }}</ion-label>
                  </ion-item>
                  <ion-item
                    *ngIf="showPersonalDetails"
                    routerDirection="root"
                    routerLink="/profile/"
                    lines="none"
                    detail="false"
                    routerLinkActive="selected"
                  >
                    <ion-icon
                      style="color: transparent"
                      aria-hidden="true"
                      slot="start"
                      ios="person-circle-outline"
                      md="person-circle-sharp"
                    ></ion-icon>
                    <ion-label>{{
                      'movacarpro_menu_personal_info' | translate | titlecase
                    }}</ion-label>
                    <ion-icon
                      *ngIf="profileHasMissingFields"
                      slot="end"
                      name="alert-circle"
                      color="warning"
                      [attr.aria-label]="'movacarpro_onboarding_doc_info_aria' | translate"
                    ></ion-icon>
                  </ion-item>
                  <ng-container *ngFor="let p of userProfilePages">
                    <ion-item
                      routerDirection="root"
                      [routerLink]="[p.url]"
                      lines="none"
                      detail="false"
                      routerLinkActive="selected"
                    >
                      <ion-icon
                        style="color: transparent"
                        aria-hidden="true"
                        slot="start"
                        [ios]="p.icon + '-outline'"
                        [md]="p.icon + '-sharp'"
                      ></ion-icon>
                      <ion-label>{{
                        p.title | translate | titlecase
                      }}</ion-label>
                      <ion-icon
                        *ngIf="p.url === '/company/' && companyHasMissingFields"
                        slot="end"
                        name="alert-circle"
                        color="warning"
                        [attr.aria-label]="'movacarpro_onboarding_doc_info_aria' | translate"
                      ></ion-icon>
                    </ion-item>
                    </ng-container>
                  </ion-menu-toggle>
                </ng-template>

                <ion-menu-toggle auto-hide="false" slot="content">
                  <ion-item lines="none" detail="false">
                    <ion-icon
                      style="color: transparent"
                      aria-hidden="true"
                      slot="start"
                      ios="globe-outline"
                      md="globe-sharp"
                    ></ion-icon>

                    <p class="change-language">
                      {{ 'change_language' | translate | titlecase }}
                    </p>
                    <ion-select
                      class="language-select"
                      (ionChange)="changeLanguage()"
                      [(ngModel)]="this.languagesService.activeLanguage"
                      [label]="'change_language' | translate | titlecase"
                    >
                      <ion-select-option
                        *ngFor="let lang of this.languagesService.languages"
                        [value]="lang"
                      >
                        {{ lang.value | translate }}
                      </ion-select-option>
                    </ion-select>
                    <ion-img
                      class="flag-icon"
                      [src]="
                        'assets/icon/' +
                        this.languagesService.activeLanguage.value +
                        '.png'
                      "
                      alt="flag icon"
                    ></ion-img>
                  </ion-item>
                </ion-menu-toggle>
              </ion-accordion>
            </ion-accordion-group>

            <ion-accordion-group #accordionGroup *ngIf="!adminMenuActive">
              <ion-accordion value="legal">
                <ion-item slot="header" lines="none" detail="false">
                  <ion-icon
                    aria-hidden="true"
                    slot="start"
                    ios="document-text-outline"
                    md="document-text-sharp"
                  ></ion-icon>
                  <ion-label class="legal-label">{{
                    'movacarpro_menu_legal' | translate
                  }}</ion-label>
                </ion-item>

                <ion-menu-toggle
                  auto-hide="false"
                  slot="content"
                  (click)="toggleAccordion()"
                >
                  <ion-item>
                    <ion-icon
                      style="color: transparent"
                      aria-hidden="true"
                      slot="start"
                      ios="document-text-outline"
                      md="document-text-sharp"
                    ></ion-icon>
                    <a [routerLink]="'/agb'">
                      {{ 'movacarpro_menu_terms_and_conditions' | translate }}
                    </a>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle
                  auto-hide="false"
                  slot="content"
                  (click)="toggleAccordion()"
                >
                  <ion-item>
                    <ion-icon
                      style="color: transparent"
                      aria-hidden="true"
                      slot="start"
                      ios="document-text-outline"
                      md="document-text-sharp"
                    ></ion-icon>
                    <a [routerLink]="'/datenschutz'">{{
                      'movacarpro_menu_privacy_policy' | translate
                    }}</a>
                  </ion-item>
                </ion-menu-toggle>

                <ion-menu-toggle
                  auto-hide="false"
                  slot="content"
                  (click)="toggleAccordion()"
                >
                  <ion-item>
                    <ion-icon
                      style="color: transparent"
                      aria-hidden="true"
                      slot="start"
                      ios="document-text-outline"
                      md="document-text-sharp"
                    ></ion-icon>
                    <a [routerLink]="'/impressum'">
                      {{ 'movacarpro_imprint' | translate }}
                    </a>
                  </ion-item>
                </ion-menu-toggle>
              </ion-accordion>
            </ion-accordion-group>
          </ng-template>

          <ng-template [ngIf]="this.authService.isLoggedIn() | async">
            <ion-menu-toggle auto-hide="false">
              <ion-item
                button=""
                lines="none"
                detail="false"
                (click)="logout()"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  ios="log-out-outline"
                  md="log-out-sharp"
                ></ion-icon>
                <ion-label style="font-weight: 400">{{
                  'Logout' | translate
                }}</ion-label>
              </ion-item>
            </ion-menu-toggle>
          </ng-template>
        </ion-list>
      </ion-content>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

  <app-update-request-modal />
  <app-forbidden-browser-modal *ngIf="!adminMode" />
</ion-app>
